import React, { useEffect, useState } from 'react';
import { Copy, Check, Mail, MessageCircle, Share2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { normalizeConfig } from './catalog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ShareDialog({ open, onOpenChange, cfg, label, name }) {
  const [link, setLink] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!open) { setLink(null); setCopied(false); return; }
    const n = normalizeConfig(cfg);
    fetch(`${API_URL}/api/share`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name || '', config: { category: n.category, room: n.room, modules: n.modules, modulesB: n.modulesB, modulesC: n.modulesC, layout: n.layout, island: n.island, mats: n.mats, led: n.led } }),
    }).then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((s) => setLink(`${window.location.origin}/partage/${s.id}`))
      .catch(() => { toast.error('Impossible de créer le lien'); onOpenChange(false); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const msg = `Regarde mon projet ${label} imaginé avec JENMA Concept : ${link}`;
  const copy = async () => { await navigator.clipboard.writeText(link); setCopied(true); toast.success('Lien copié'); };
  const native = () => navigator.share?.({ title: `Mon projet ${label} - JENMA Concept`, text: msg, url: link });
  const btn = 'flex flex-col items-center gap-2 border border-white/10 hover:border-[#a68966] py-4 text-[10px] uppercase tracking-[0.2em] text-gray-300 hover:text-[#e6d3b3] transition-colors';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#151515] border-[#a68966]/30 text-gray-200 w-[calc(100%-2rem)] max-w-md" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle className="font-playfair text-2xl text-white">Partager mon projet</DialogTitle>
          <DialogDescription className="text-gray-400">La personne pourra voir le plan, les élévations et la perspective, puis créer sa propre version sans modifier la vôtre.</DialogDescription>
        </DialogHeader>
        {!link ? <Loader2 className="w-5 h-5 animate-spin text-[#a68966] mx-auto my-6" /> : (
          <>
            <div className="flex border border-white/10">
              <input readOnly value={link} data-testid="share-link-input" className="flex-1 bg-[#0f0f0f] px-3 py-3 text-xs text-gray-300 outline-none min-w-0" onFocus={(e) => e.target.select()} />
              <button type="button" onClick={copy} data-testid="share-copy-btn" className="px-4 bg-[#a68966] text-[#1a1a1a] hover:bg-[#b89c78] transition-colors">{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}</button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp" className={btn}><MessageCircle className="w-5 h-5" />WhatsApp</a>
              <a href={`mailto:?subject=${encodeURIComponent(`Mon projet ${label} - JENMA Concept`)}&body=${encodeURIComponent(msg)}`} data-testid="share-email" className={btn}><Mail className="w-5 h-5" />Email</a>
              <button type="button" onClick={navigator.share ? native : copy} data-testid="share-native" className={btn}><Share2 className="w-5 h-5" />Autre</button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
